import Course from "src/components/course";

export default function Courses() {
  return (
    <div className='w-11/12 max-w-7xl mx-auto'>
      <Course />
    </div>
  );
}
